import { render, staticRenderFns } from "./PrintInvoiceStandardTab.vue?vue&type=template&id=438e3c14&scoped=true&"
import script from "./PrintInvoiceStandardTab.vue?vue&type=script&lang=js&"
export * from "./PrintInvoiceStandardTab.vue?vue&type=script&lang=js&"
import style0 from "./PrintInvoiceStandardTab.vue?vue&type=style&index=0&id=438e3c14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e3c14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
